@use '../../../../../styles/Colors.scss' as Colors;
@use '../../../../../styles/Constants.scss' as Constants;

.section {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-m;
	border: 1px solid Colors.$col-greyConnection;
	padding: Constants.$val-spacing-s;
	width: 100%;
	min-width: 0;
}

.meta-field {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-xxs;
	min-width: 0;
}

.hint-title {
	font-size: Constants.$val-fontSizeRegular;
	color: Colors.$col-greyDark;
}

.hint-sub {
	font-size: Constants.$val-fontSizeRegular;
	color: Colors.$col-grey;
}

.report-type-filter {
	display: flex;
	border: 1px solid Colors.$col-greyConnection;
	border-radius: Constants.$val-spacing-s;
	width: fit-content;
	background-color: Colors.$col-design-grey13;
	color: Colors.$col-design-grey11;

	.filter-option {
		flex: 1;
		min-width: 150px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: Constants.$val-spacing-xs Constants.$val-spacing-m;
		cursor: pointer;
		user-select: none;

		&:first-child {
			border-top-left-radius: Constants.$val-spacing-s;
			border-bottom-left-radius: Constants.$val-spacing-s;
		}

		&:last-child {
			border-top-right-radius: Constants.$val-spacing-s;
			border-bottom-right-radius: Constants.$val-spacing-s;
		}

		&.active {
			background-color: Colors.$col-design-blue500;
			color: Colors.$col-white;
		}
	}
}

.fields-pane {
	display: flex;
	flex-direction: column;
	border: 1px solid Colors.$col-greyConnection;
	padding: Constants.$val-spacing-s;
	min-height: 500px;
}

.picker-area {
	flex: 1 1 auto;
	min-height: 0;
	min-width: 0;
	border: 1px solid Colors.$col-greyConnection;
	padding: Constants.$val-spacing-s;
	overflow: hidden;
}

.picker-inner {
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.cards-scroll {
	flex: 1 1 auto;
	min-height: 0;
	overflow: auto;
}

.cards-grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: Constants.$val-spacing-m;
	align-items: start;
}

.card-rt {
	display: flex;
	flex-direction: column;
	border: 1px solid Colors.$col-design-gray300;
	overflow: hidden;
	min-width: 0;
	height: 500px;
	background-color: Colors.$col-design-red4;

	&.resolved {
		background-color: Colors.$col-design-orange5;
	}
}

.card-header {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-xs;
	padding: Constants.$val-spacing-s Constants.$val-spacing-m;
	font-size: Constants.$val-fontSizeSmall;
	border-bottom: 1px solid Colors.$col-design-gray300;
}

.card-title {
	display: flex;
	flex-direction: column;
	align-items: start;
	gap: Constants.$val-spacing-xs;
	font-size: Constants.$val-fontSizeRegular;
	font-weight: 600;
	color: Colors.$col-greyDark;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	text-transform: uppercase;
}

.card-meta {
	font-size: Constants.$val-fontSizeSmall;
	color: Colors.$col-grey;
}

.card-body {
	flex: 1 1 auto;
	min-height: 0;
	overflow: auto;
	padding: Constants.$val-spacing-s Constants.$val-spacing-s;
	background-color: transparent;
}

@mixin block {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-s;
	padding: Constants.$val-spacing-xs;
}

.block {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-s;
	background-color: Colors.$col-design-blue100;
	border: 2px solid Colors.$col-design-blue300;
	padding: Constants.$val-spacing-xs;

	&__primary {
		@include block;
		background-color: Colors.$col-design-blue100;
		border: 2px solid Colors.$col-design-blue300;
	}

	&__secondary {
		@include block;
		background-color: inherit;
		border: 2px solid Colors.$col-design-blue300;
	}
}

.block-header {
	text-transform: uppercase;
	font-weight: 600;

	&__main {
		color: Colors.$col-design-blue500;
		text-transform: uppercase;
	}

	&__secondary {
		color: Colors.$col-design-grey11;
		text-transform: uppercase;
	}
}

.block-fields {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-s;
	font-size: Constants.$val-fontSizeSmall;
}

.block-field {
	display: flex;
	flex-direction: row;
	padding: Constants.$val-spacing-xs;

	&__primary {
		background-color: Colors.$col-design-blue50;
	}

	&__secondary {
		background-color: Colors.$col-white;
	}
}

.block-field-radio {
	display: flex;
	flex-direction: row;
}

.primary-blocks {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-xs;
	background: Colors.$col-design-blue200;
	border-radius: Constants.$val-spacing-xs;
	padding: Constants.$val-spacing-xs;
	margin-bottom: Constants.$val-spacing-s;
}

.secondary-blocks {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-xs;
	background: Colors.$col-design-gray50;
	border-radius: Constants.$val-spacing-xs;
	padding: Constants.$val-spacing-xs;
	border: 1px solid Colors.$col-lighterGrey;
	margin-bottom: Constants.$val-spacing-s;
}


.dialog {
	padding-top: 48px;
}

.action-button {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-xxs;
	color: Colors.$col-design-blue500;
	font-size: Constants.$val-fontSizeRegular;

	&--disabled {
		color: Colors.$col-design-grey10;
	}

	&:hover {
		cursor: pointer;
	}
}

.info-icon {
	color: Colors.$col-design-blue500;
	cursor: pointer;
}

.tooltip {
	display: flex;
	flex-direction: column;
	align-items: center;
	flex-direction: column;
	text-align: center;
}

.card-warn-corner {
	font-size: Constants.$val-fontSizeBig;
	line-height: 1;
	color: red;
}

.card-name {
	display: flex;
	flex-direction: row;
	align-items: flex-end;
	justify-content: space-between;
	width: 100%;
}

.updated-at {
	color: Colors.$col-design-grey500;
	font-family: Roboto;
	font-size: Constants.$val-fontSizeSmall;
	font-style: italic;
	font-weight: 400;
	text-transform: none;
	padding-bottom: Constants.$val-inputPadding-lr;
	padding-top: Constants.$val-spacing-s;
}